// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"263":"c43f3e27","458":"a9634bc4","488":"d6f3d69b","936":"75ec541f"}[chunkId] + ".chunk.css";
};